import StandardError from '../StandardError'

export default class NotReceived extends StandardError {
  constructor() {
    super(
      'Hi pal, it appears this item has not been marked as received. Please try another request.'
    )
  }
}
